/**
 * パスワードバリデーション用の正規表現
 * 要件: 10文字以上 / 英大文字・英小文字・数字・記号をそれぞれ1種類以上含む
 */
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{10,}$/;

/**
 * HTML pattern 属性用のパターン文字列
 * PASSWORD_REGEX から ^$ を除いた形式（pattern属性は暗黙的に^...$で囲まれるため）
 */
export const PASSWORD_PATTERN =
  '(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{10,}';
